export const TAG_MIDDLE_NAME = "3d";
export const DEG2RAD = Math.PI / 180;
